import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/mod-manager/v1/core/interface/IStore'

export default defineStore('systemModManagerStoreV1', {
  state: (): IStore => {
    return {
      modules: {},
    }
  },
})
